<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('areaname')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>东盟矿业标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.areaname" placeholder="请输入标题" class="input areaname" @blur="detection(11, 43, form.areaname)"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>标题图片
          </td>
          <td class="after">
              <el-upload
                v-if="this.$route.path === '/Dmkygl'"
                :action="url"
                :limit="1"
                list-type="picture-card"
                ref="uploadPic"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess"
                :on-remove="handleRemovePicture"
                @mouseover.native="getPhoUrl"
                :on-exceed="exceed">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-upload
                v-else
                :action="url"
                :limit="1"
                list-type="picture-card"
                :file-list="fileList"
                :on-change="handleEditChange"
                :class="{hide:hideUploadEdit}"
                :before-upload="beforeUploadPicture"
                :on-preview="handlePictureCardPreview"
                :on-success="onSuccess"
                :on-remove="handleRemovePicture"
                @mouseover.native="getPhoUrl"
                :on-exceed="exceed">
                <i class="el-icon-plus"></i>
              </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width=100% :src="dialogImageUrl" />
            </el-dialog>
          </td>
        </tr>
        <tr v-if="!checked_External_links">
          <td class="td_left">
            <span v-if="isContentMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>东盟矿业内容
          </td>
          <td class="after">
            <div id="editor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>东盟矿业简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" class="introduce" v-model="form.areamemo"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Dmkygl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/DmkyUpdate'">确定</el-button>
      <el-button type="success" @click="isPass()" v-if="this.$route.path === '/DmkyLook'">通过</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Dmkygl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/DmkyUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-if="this.$route.path === '/DmkyLook'">不通过</el-button>
      <el-button  @click="backtrackLook()" v-if="this.$route.path === '/DmkyLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 安进
 * 东盟矿业添加
 */
import {mapState} from 'vuex'
export default {
  components: {
  },
  props: ['updataID', 'lookID'],
  data()
  {
    //链接验证规则
    let InputFromurl = (rule, value, callback) =>
    {
      let regtel = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/
      if (value)
      {
        if (!regtel.test(value))
          callback(new Error('请输入正确来源链接，http://www.'))
        else
          callback()
      }
      else
        callback()
    }
    return {
      url: '',
      checked_External_links: false,
      form: {
        areaname: '',
        areamemo: '',
        thumb: '',
        content: '',
        parentid: 0
      },
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList: [{url: ''}],
      examine: '',
      //rules对象的属性名要与表单中prop绑定的名字一致
      rules: {
        fromurl: [
          { validator: InputFromurl, trigger: 'blur' }
        ]
      },
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      //表名
      tabname: 'dmcn_area',
      tabContentname: 'dmcn_area_data',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then(res =>
        {
          this.classifydata = []
          res.forEach(e => this.classifydata.push({ value: e.id, label: e.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    // 添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 43,
        retAtt: 1,
        areaname: this.form.areaname,
        areamemo: this.form.areamemo,
        pic2: this.form.thumb,
        parentid: this.form.parentid,
        examine: this.examine
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'addWithId',
          _major: 11,
          _minor: 44,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
      })
    },
    // 获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/DmkyUpdate')
        this.getData()
      else if (this.$route.path === '/DmkyLook')
        this.getData()
      else if (this.$route.path === '/Dmkygl')
        return false
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 43,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.areaname = ret[0].areaname
        this.form.areamemo = ret[0].areamemo
        this.form.thumb = ret[0].pic2
        this.fileList[0].url = ret[0].pic2 !== '' ? ret[0].pic2 : 'static/images/moren.jpg'
      })
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 44,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.form.content = ret[0].content
        // 重新设置编辑器内容
        this.editor.txt.html(ret[0].content)
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 43,
        retAtt: 1,
        id: this.updataID,
        areaname: this.form.areaname,
        areamemo: this.form.areamemo,
        pic2: this.form.thumb
      }
      window.post.getPost(obj).then((ret) =>
      {
        let paras1 = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 44,
          retAtt: 1,
          id: this.updataID,
          content: this.form.content
        }
        window.post.getPost(paras1).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.$router.push({path: '/Dmkygl'})
            this.$store.commit('onActiveName', '1')
          }
        })
      })
    },
    // 返回
    backtrack()
    {
      this.$router.push({path: '/Dmkygl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToExamine'})
      this.$store.commit('onActiveName', '1')
    },
    //不通过
    notPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 10,
        retAtt: 1,
        id: this.updataID,
        examine: 4
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 10, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 10,
        retAtt: 1,
        id: this.updataID,
        examine: examine
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    // //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/DmkyAdd.vue